import { MerchantEmailTrigger } from "@redotech/redo-merchant-email-common/merchant-email-trigger";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const fireMerchantEmailTriggerRpc = {
  name: "fireMerchantEmailTrigger" as const,
  input: z.object({ trigger: createEnum(MerchantEmailTrigger) }),
  output: z.object({ fired: z.boolean() }),
};
